const LOCATION_TYPE = [
    'Virtual',
    'Patient Address',
    'Clinic'
];

type LOCATION_TYPE = typeof LOCATION_TYPE;

export default LOCATION_TYPE;
